module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/interaktivniMapa@2x-3459c5b424bd90e619ab5b73abf98440.png";